const CRUISE_PRICING_CONSTANTS = {
    DEFAULT_CURRENCY: 'USD',
    DEFAULT_TOTAL: '0.0',
    DEFAULT_LOCALE: 'en-us',
};

export { CRUISE_PRICING_CONSTANTS };
